import { useEffect, useState } from "react";
import { createTxpg } from "../../services/merchant";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";

const EditTxpg = ({ setEditTxpgModal, hasTxpg, id, txpgInfo }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [terminalId, setTerminalId] = useState("");
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const updateTxpg = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await createTxpg({
        username,
        password,
        terminalId,
        partyId: +id,
      });
      setLoading(false);
      toast.success(res.message);
      setEditTxpgModal(false);
      queryClient.invalidateQueries({ queryKey: ["fetchTxpgDetails"] });
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    setUsername(txpgInfo.username || "");
    setPassword(txpgInfo.password || "");
    setTerminalId(txpgInfo.terminalId || "");
  }, [txpgInfo.username, txpgInfo.password, txpgInfo.terminalId]);

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex justify-center items-center">
      <div className="modal-content flex flex-col justify-center h-fit w-[400px] bg-white p-6 rounded shadow-lg relative">
        <button
          className="close absolute top-3 right-2 py-1 cursor-pointer px-4 text-orange-400 border border-orange-400 rounded-md"
          onClick={() => setEditTxpgModal(false)}
        >
          x
        </button>
        <form onSubmit={updateTxpg}>
          <div className="flex flex-col mt-6">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 focus:ring-offset-0 
             focus:shadow-[0_0_10px_rgba(251,146,60,0.8)] w-[350px] h-[50px] bg-form-background border rounded-md p-2 text-navy-blue"
            />
          </div>
          <div className="flex flex-col mt-6">
            <label htmlFor="password">Password</label>
            <input
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 focus:ring-offset-0 
             focus:shadow-[0_0_10px_rgba(251,146,60,0.8)] w-[350px] h-[50px] bg-form-background border rounded-md p-2 text-navy-blue"
            />
          </div>
          <div className="flex flex-col mt-6">
            <label htmlFor="password">Terminal Id</label>
            <input
              type="text"
              value={terminalId}
              onChange={(e) => setTerminalId(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 focus:ring-offset-0 
             focus:shadow-[0_0_10px_rgba(251,146,60,0.8)] w-[350px] h-[50px] bg-form-background border rounded-md p-2 text-navy-blue"
            />
          </div>
          <div className="mt-4">
            <button
              disabled={loading}
              className={`relative flex items-center justify-center w-[350px] h-[50px] rounded-md text-white font-medium overflow-hidden transition-all duration-300 ${
                loading
                  ? "bg-primary cursor-not-allowed"
                  : "bg-primary hover:bg-[rgba(var(--primary-rgb),0.6)]"
              }`}
              type="submit"
            >
              {loading ? (
                <span className="relative flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  <span className="text-white">Updating...</span>
                  <span className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent"></span>
                </span>
              ) : (
                <span>{hasTxpg ? "Update" : "Create"}</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTxpg;
